import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navigation from "./Navigation.jsx";
import LanguageSwitcher from "./LanguageSwitcher.jsx";

export default function Header({ lang }) {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    function handlePointerDown(event) {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    function handleKeyDown(event) {
      if (event.key === "Escape") setMenuOpen(false);
    }
    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [menuOpen]);

  return (
    <header
      ref={headerRef}
      className="tl-header"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "32px",
        paddingTop: "20px",
        paddingBottom: "20px",
        background: "var(--color-bg)",
        borderBottom: "1px solid rgba(254,250,239,0.08)",
        position: "sticky",
        top: 0,
        zIndex: 20,
      }}
    >
      <Link to={`/${lang}/`} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <img src="/assets/brand/logo-mark-cream.svg" alt={t("nav.logoAlt")} width={56} height={36} style={{ height: "36px", width: "auto" }} />
        <span style={{ fontFamily: "var(--font-serif)", fontSize: "20px", color: "var(--color-gold)" }}>Tales&amp;Legends</span>
      </Link>

      <div className="tl-header-nav-desktop" style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
        <Navigation lang={lang} />
        <LanguageSwitcher lang={lang} />
      </div>

      <button
        type="button"
        className="tl-burger-button"
        onClick={() => setMenuOpen((open) => !open)}
        aria-expanded={menuOpen}
        aria-controls="mobile-menu"
        aria-label={menuOpen ? t("nav.menuClose") : t("nav.menuOpen")}
        style={{
          alignItems: "center",
          justifyContent: "center",
          width: "44px",
          height: "44px",
          background: "transparent",
          border: "none",
          color: "var(--color-cream)",
          cursor: "pointer",
        }}
      >
        {menuOpen ? (
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
            <line x1="5" y1="5" x2="19" y2="19" />
            <line x1="19" y1="5" x2="5" y2="19" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
            <line x1="4" y1="7" x2="20" y2="7" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="17" x2="20" y2="17" />
          </svg>
        )}
      </button>

      {menuOpen && (
        <div
          id="mobile-menu"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            display: "flex",
            flexDirection: "column",
            gap: "18px",
            padding: "20px 24px 28px",
            background: "var(--color-bg)",
            borderBottom: "1px solid rgba(254,250,239,0.08)",
          }}
        >
          <Navigation lang={lang} vertical onNavigate={() => setMenuOpen(false)} />
          <LanguageSwitcher lang={lang} />
        </div>
      )}
    </header>
  );
}
